<template>
  <section class="active-event" v-if="event">
    <div v-if="event.eventUsers.length !== 0 && event.eventUsers.length === 1">
      <img
        class="active-event__speaker-image"
        v-bind:src="
          getSpeakerImage(
            getSpeakerNameNormalized(event.eventUsers[0].user.firstName + event.eventUsers[0].user.lastName),
          )
        "
        v-bind:alt="`${event.eventUsers[0].user.firstName} ${event.eventUsers[0].user.lastName}`"
      />
    </div>
    <div class="active-event__content">
      <div class="active-event__title" v-if="event.name">
        <span>{{ event.name }}</span>
        <div class="active-event__in-progress">U TIJEKU</div>
      </div>
      <div class="active-event__speakers" v-if="event.eventUsers.length !== 0">
        <div
          class="active-event__user-details"
          v-for="(eventUser, index) in getSortedEventUsers(event)"
          v-bind:key="eventUser.userId"
        >
          <div class="user-details__user-name">
            {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}
            <div class="user-details__user-title" v-if="eventUser.user && eventUser.user.lecturerTitle">
              <span v-if="eventUser.userEventRole === 'Moderator'">Moderator,</span>
              {{ eventUser.user.lecturerTitle }}
            </div>
            <span v-if="index !== event.eventUsers.length - 1">,</span>
          </div>
          <div class="user-details__sponsor-logo">
            <img :class="getSponsorNameNormalized(eventUser.user.id)" :src="getSponsorLogo(eventUser.user.id)" />
          </div>
        </div>
        <div class="active-event__watch">
          <a href="" target="_blank" class="watch__button">Gledaj</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { eventMixin } from '@/mixins';
import { sponsorLogoExtensions } from '@/config';

export default {
  name: 'ActiveEvent',
  mixins: [eventMixin],
  props: {
    event: {},
  },
  data() {
    return {
      sponsorLogoExtensions,
    };
  },
  methods: {
    getSponsorNameNormalized(userId) {
      const eventUser = this.event.eventUsers.find(userEvent => userEvent.user.id === userId);

      return eventUser.user.company.name.replace(/\s/g, '').toLowerCase();
    },
    getSponsorLogo: function (userId) {
      const eventUser = this.event.eventUsers.find(userEvent => userEvent.user.id === userId);
      const sponsorNameNormalized = eventUser.user.company.name.replace(/\s/g, '').toLowerCase();

      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${sponsorNameNormalized}.${this.sponsorLogoExtensions[sponsorNameNormalized]}`);
    },
    getSpeakerImage: function (speakerNameNormalized) {
      // eslint-disable-next-line
      return require(`@/assets/speakers/images/${speakerNameNormalized}.jpg`);
    },
    getSpeakerNameNormalized: function (speakerName) {
      return speakerName.replace(/\s/g, '').toLowerCase();
    },
  },
};
</script> 

<style scoped>
.active-event {
  display: flex;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 40px;
  margin: auto;
  max-width: 1030px;
  padding: 64px;
  margin-top: 160px;
}

.active-event__content {
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.active-event__title {
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.active-event__speaker-image {
  width: 256px;
  height: 256px;
  border-radius: 26px;
}

.active-event__speakers {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.active-event__user-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-details__user-name {
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
}

.user-details__user-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
}

.user-details__sponsor-logo {
  display: flex;
  justify-content: space-between;
  border-left: 1px solid rgba(255, 255, 255, 0.27);
  padding-left: 52px;
}

.user-details__sponsor-logo > img {
  max-height: 90px;
  max-width: 140px;
}

.active-event__watch {
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
}

.watch__button {
  background: #30cec2;
  border-radius: 15px;
  padding: 12px 32px;
  color: #0a181b;
  text-decoration: none;
  font-weight: 800;
}

.watch__button:hover {
  background: #35e5d8;
}

.active-event__in-progress {
  display: inline-block;
  border: 1px solid #d73246;
  border-radius: 6px;
  color: #d73246;
  font-family: Fuse V.2 Display;
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  padding: 2px 8px;
  line-height: 12px;
  margin-left: 8px;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}

.active-event__in-progress::before {
  content: '';
  background-color: #d73246;
  display: inline-block;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  animation: pulse-red 2s infinite;
}

@media screen and (max-width: 1150px) {
  .active-event {
    margin: 120px 16px 0 16px;
  }
}

@media screen and (max-width: 900px) {
  .active-event {
    padding: 16px;
    flex-direction: column;
    border-radius: 20px;
  }

  .active-event__content {
    padding: 0;
    margin-top: 16px;
  }

  .active-event__title {
    flex-direction: column;
    align-items: flex-start;
  }

  .active-event__in-progress {
    margin-left: 0;
  }

  .user-details__sponsor-logo {
    padding: 0;
    border: none;
  }
}

</style>